<template>
  <div class="list">
    <div class="searchBox">
      <img src="@/assets/resourcesManage/sousuo_ic_daoyou @3x.png" alt />
      <input type="text" v-model="searchName" :style="{ fontSize: '14px' }" placeholder="请输入资源单体名称" @click="goSearch" />
    </div>
    <div class="selectBox">
      <div class="selectType" v-if="typeListCity.length">
        <div class="cityType" @click="selectCity">
          <span class="cityName">{{ cityChange }}</span>
          <img class="cityNameImg" src="@/assets/resourcesManage/ic_jiantou_down2@2x.png" alt />
        </div>
      </div>
      <div class="selectType" v-else>
        <div class="cityType">
          <span class="cityName">{{ cityChange }}</span>
        </div>
      </div>
      <div class="selectType">
        <div class="cityType" @click="bandleDirectories">
          <span class="cityName">{{ directories }}</span>
          <img class="cityNameImg" src="@/assets/resourcesManage/ic_jiantou_down2@2x.png" alt />
        </div>
      </div>
    </div>

    <div class="centerBox">
      <div class="scenicList" >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadMoreList"
          v-if="listData.length > 0"
          :offset="100"
          :error.sync="error"
        >
          <div class="scenicItem" @click="toScenicDetele(ind)" v-for="(item, ind) in listData" :key="ind">
              <div class="scenicItem_wrap">
                <div class="scenicItem_item">
                    <div class="scenicItem_title">{{ item.monomerName }}</div>
                    <div class="scenicItem_tag line_border_green" v-if="item.evaluateScoreGrade">
                      <div>{{ item.evaluateScoreGrade }}</div>
                    </div>
                </div>
                <div class="scenicItem_nav">
                    <div class="scenicLeftItem">
                        <div class="scenicLeftTitle">主类</div>
                        <div class="scenicLeftNav">{{ item.mainClassifyName }}</div>
                    </div>
                    <div class="scenicLeftItem">
                        <div class="scenicLeftTitle">亚类</div>
                        <div class="scenicLeftNav">{{ item.subClassifyName }}</div>
                    </div>
                    <div class="scenicLeftItem">
                        <div class="scenicLeftTitle">基本类型</div>
                        <div class="scenicLeftNav">{{ item.basicClassifyName }}</div>
                    </div>
                    <div class="scenicLeftItem">
                        <div class="scenicLeftTitle">所属地区</div>
                        <div class="scenicLeftNav">{{ item.location }}</div>
                    </div>
                </div>
              </div>
          </div>
        </van-list>
      </div>
      <div class="noScenicList" v-if="isShowNo">
        <div class="noScenic">
          <div class="noScenicItem">
            <div class="noScenicItemImg">
              <img src="../../../../assets/appointment/ic_wuxingxi@3x.png" alt>
            </div>
            <div class="noScenicItemContent">
              该筛选条件下，没有查询到任何数据哦
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 区域 -->
    <common-picker :cols="cols" ref="commonpicker" :typeList="typeListCity"  @getTypeValue="getCityValue"></common-picker>
    <!-- 景观 -->
    <common-picker ref="commonpickerdirectories" :typeList="typeListScenery" :cols="3" @getTypeValue="getDirectoriesList"></common-picker>
  </div>
</template>

<script>
    import api from '../../../../service/modules/resourcesManage';
    import commonPicker from '../../../../components/base/commonPicker';
    // import rangTime from '../../../../../components/rangTime1';
    // import { timeType1 } from '../../../../../utils/configJson';

    export default {
        components: {
            'common-picker': commonPicker,
            // rangTime
        },
        data () {
            return {
                finished: false,
                loading: false,
                cols: 2,
                typeListCity: [],
                typeListScenery: [],
                cityChange: this.$route.query.name,
                directories: this.$route.query.monomerName || '全部类型',
                // areaCode: JSON.parse(localStorage.getItem('auth')).areaCode,

                listData: [],
                // name: this.$route.query.name || '',
                searchName: '',

                pageIndex: 1,
                pageSize: 10,
                total: 0,
                error: false,
                /** areaLevel  1省,2市,3区县 */
                // localNum: JSON.parse(localStorage.getItem('auth')).areaLevel,
                areaCode: this.$route.query.areaCode,
                regionLevel: this.$route.query.regionLevel,
                regionId: this.$route.query.regionId,
                classifyId: '',
                classifyLevel: '1',
                level: localStorage.getItem('level'),
                monomerName: this.$route.query.monomerName || '', // 搜索
                isShowNo: false
            }
        },
        created () {
            this.getAppointmentPageList(); /** 列表 */
            this.getPercentageClassify();
            this.getCityList();
        },
        methods: {
            loadMoreList () {
                this.getAppointmentPageList()
            },
           
            /** 获取列表data */
            getAppointmentPageList () {
                this.loading = true;
                api.getDirectories({
                    // areaCode: this.areaCode,
                    // regionLevel: this.regionLevel,
                    regionId: this.regionId,
                    classifyId: this.classifyId,
                    classifyLevel: this.classifyLevel,
                    monomerName: this.monomerName,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize

                }).then(res => {
                    if (res.ret === 0) {
                        this.finished = false;
                        this.loading = false;
                        this.listData = [ ...this.listData, ...res.data.list ];
                        this.pageIndex++;
                        this.total = res.data.pageination.total;
                        if (this.total <= res.data.pageination.currentPage * res.data.pageination.pageSize) {
                            this.finished = true;
                        }
                        this.isShowNo = false;
                        if (res.data.list.length === 0) {
                            this.isShowNo = true;
                        } 
                    } else {
                        this.$Message.error('res.data.msg')
                    }
                })
            },

            /** 跳转名录详情 */
            toScenicDetele (e) {
                this.$router.push({
                    path: '/resourcesManage/directoriesDetele',
                    query: {
                        id: this.listData[e].id
                    }
                })
            },
            selectCity () {
                // if(this.localNum === 3) return;
                this.$refs.commonpicker.showPicker();
            },
            bandleDirectories () {
                this.$refs.commonpickerdirectories.showPicker();
            },
            getDirectoriesList (val) {
                if (val && val.length === 3) {
                    if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text === '全部' && val[0].text === '全部类型') {
                        this.directories = '全部类型';
                        this.classifyId = '';
                        this.classifyLevel = '';
                    } else if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text === '全部' && val[0].text !== '全部类型') {
                        this.directories = val[0].text;
                        this.classifyId = val[0].value;
                        this.classifyLevel = val[0].level;
                    } else if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text !== '全部') {
                        this.directories = val[1].text;
                        this.classifyId = val[1].value;
                        this.classifyLevel = val[1].level;
                    } else {
                        this.directories = val[2].text;
                        this.classifyId = val[2].value;
                        this.classifyLevel = val[2].level;
                    }
                } else if (val && val.length === 2) {
                    if (val[1].text === '全部') {
                        this.directories = val[0].text;
                        this.classifyId = val[0].value;
                        // this.classifyLevel = val[0].text === '全部' ? '1' : val[0].level;
                        this.classifyLevel = val[0].level;
                    } else {
                        this.directories = val[1].text;
                        this.classifyId = val[1].value;
                        this.classifyLevel = val[1].level;
                    }
                } else if (val && val.length === 1) {
                    this.directories = val[0].text;
                    this.classifyId = val[0].value;
                    this.classifyLevel = val[0].level;
                }
                this.pageIndex = 1; /** 页码重置 */
                this.listData = []; /** 数据重置 */
                this.getAppointmentPageList();
            },

            // 切换城市
            getCityValue (value) {
                if (value && value.length === 2) {
                    if (value[1].text === '全部') {
                        this.cityChange = value[0].text;
                        this.areaCode = value[0].value;
                        this.regionLevel = value[0].level;
                        this.regionId = value[0].id;
                    } else {
                        this.cityChange = value[1].text;
                        this.areaCode = value[1].value;
                        this.regionLevel = value[1].level;
                        this.regionId = value[1].id;
                    }
                } else if (value && value.length === 1) {
                    this.cityChange = value[0].text;
                    this.areaCode = value[0].value;
                    this.regionLevel = value[0].level;
                    this.regionId = value[0].id;
                }
                this.pageIndex = 1; /** 页码重置 */
                this.listData = []; /** 数据重置 */
                this.getAppointmentPageList();
            },

            // 地文景观
            async getPercentageClassify () {
                let res = await api.getDirectoriesCodingClassify();
                if (res.ret === 0) {
                    let obj = {
                        text: '全部类型',
                        value: '',
                        shortName: '全部类型',
                        level: '',
                        children: [
                            {
                                text: '全部',
                                value: '',
                                shortName: '全部',
                                level: '',
                                children: [
                                    {
                                        text: '全部',
                                        value: '',
                                        shortName: '全部',
                                        level: '',
                                        
                                    }
                                ]
                            }
                        ]
                    }
                    let arr = res.data.map(item => {
                        return {
                            text: item.classifyName,
                            shortName: item.classifyName,
                            level: item.classifyLevel,
                            value: item.id,
                            pId: item.pId,
                            children: item.children.map(e => {
                                return {
                                    text: e.classifyName,
                                    shortName: e.classifyName,
                                    level: e.classifyLevel,
                                    value: e.id,
                                    pId: e.pId,
                                    children: e.children.map(el => {
                                        return {
                                            text: el.classifyName,
                                            shortName: el.classifyName,
                                            level: el.classifyLevel,
                                            value: el.id,
                                            pId: el.pId
                                        }
                                    })
                                }
                            })
                        }
                    })
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].children) {
                            let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                            let newArr = arr[i].children.concat([]);
                            arr[i].children = cityChild.concat(newArr)
                        }
                        for (var j = 0; j < arr[i].children.length; j++) {
                              if (arr[i].children[j].children) {
                                let cityChildren = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                                let newBrr = arr[i].children[j].children.concat([]);
                                arr[i].children[j].children = cityChildren.concat(newBrr)
                            }
                        }
                    }
                    arr.unshift(obj);
                    this.typeListScenery = [];
                    this.typeListScenery.push(arr);
                }
            },

            async getCityList () {
                let res = await api.getDirectoriesRegions({ regionId: this.regionId });
                // let res = await api.getDirectoriesRegions({ areaCode: this.$route.query.areaCode, regionLevel: this.$route.query.regionLevel });
                if (res.ret === 0) {
                  if (this.level == 1) { // 省级权限
                      this.cols = 2;
                      let obj = {
                          text: this.$route.query.name,
                          value: this.$route.query.areaCode,
                          shortName: this.$route.query.name,
                          level: this.$route.query.regionLevel,
                          id: this.regionId,
                          children: [
                              {
                                  text: '全部',
                                  value: '',
                                  shortName: '全部',
                                  level: ''
                              }
                          ]
                      }
                      let arr = res.data.map(item => {
                          return {
                              text: item.fullName,
                              shortName: item.fullName,
                              value: item.areaCode,
                              level: item.regionLevel,
                              id: item.id,
                              pId: item.pId,
                              children: item.children.map(e => {
                                  return {
                                      text: e.fullName,
                                      shortName: e.fullName,
                                      value: e.areaCode,
                                      level: e.regionLevel,
                                      id: e.id,
                                      pId: e.pId
                                  }
                              })
                          }
                      })
                      for (var i = 0; i < arr.length; i++) {
                          if (arr[i].children) {
                              let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                              let newArr = arr[i].children.concat([]);
                              arr[i].children = cityChild.concat(newArr)
                          }
                      }
                      arr.unshift(obj);
                      this.typeListCity = [];
                      this.typeListCity.push(arr);
                  } else if (this.level == 2) {
                      this.cols = 1;
                      let objBrr = {
                          text: this.$route.query.name,
                          value: this.$route.query.areaCode,
                          shortName: this.$route.query.name,
                          level: this.$route.query.regionLevel,
                      }
                      let brr = res.data.map(item => {
                          return {
                              text: item.fullName,
                              shortName: item.fullName,
                              value: item.areaCode,
                              level: item.regionLevel,
                              id: item.id,
                              pId: item.pId
                          }
                      })
                      brr.unshift(objBrr);
                      this.typeListCity = [];
                      this.typeListCity.push(brr);
                  }
                }
            },
            goSearch () {
                this.$router.push({
                    path: '/resourcesManage/search',
                    query: {
                      // areaCode: this.$route.query.areaCode,
                      // regionLevel: this.$route.query.regionLevel,
                      regionId: this.regionId,
                      name: this.$route.query.name
                    }
                })
            }
        }
    }
</script>

<style lang="less">
  .list {
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    background-color: #fbfbfb;
    .searchBox {
      margin: 8px 12px;
      background-color: #f5f5f5;
      border-radius: 2px;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #eee;

      > img {
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 10px;
        left: 16px;
        vertical-align: middle;
      }

      > input {
        font-family: PingFang SC;
        width: 100%;
        height: 36px;
        line-height: 36px;
        padding: 0 16px 0 40px;
        box-sizing: border-box;
        border-radius: 2px;
        background-color: #f5f5f5;
      }
      input::-webkit-input-placeholder {
        color: #999999;
      }
      input::-moz-input-placeholder {
        color: #999999;
      }
      input::-ms-input-placeholder {
        color: #999999;
      }
    }
    .selectBox {
      display: flex;
      justify-content: left;
      .selectType {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // font-size: 14px;
        // font-weight: bold;
        // color: #4A4A4A;
        padding: 16px 8px 12px 16px;
        .cityType {
          // padding-top: 16px;
          .cityName {
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-right: 6px;
            max-width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .cityNameImg {
            display: inline-block;
            width: 6px;
            height: 4px;
            // margin-top: 6px;
            vertical-align: middle;
          }
        }
      }
    }
    .centerBox {
      margin: 0 12px 15px 12px;
      .scenicList {
          .scenicItem {
              .scenicItem_wrap {
                padding: 16px 16px 14px 16px;
                background-color: #fff;
                box-sizing: border-box;
                overflow: hidden;
                box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
                border-radius:3px;
                margin-bottom: 12px;
                .scenicItem_item {
                    margin-bottom: 14px;
                    display: flex;
                    justify-content: left;
                    align-items: top;
                    .scenicItem_title{
                        font-size: 14px;
                        font-weight: bold;
                        color: #333;
                        max-width: 260px;
                    }
                    .scenicItem_tag {
                        margin-left: 8px;
                        padding-bottom: 1px;
                        font-size: 14px;
                        // font-weight: 400;
                        height: 14px;
                        min-width: 28px;
                        color: #36B374;
                        // border: 1px solid #36B374;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        div {
                            text-align: center;
                            -webkit-transform: scale(0.70);
                            }
                    }
                }
                .scenicItem_nav {
                    .scenicLeftItem {
                            display: flex;
                            height: 22px;
                            line-height: 22px;
                        .scenicLeftTitle {
                            color: #999999;
                            width: 68px;
                            font-size: 14px;
                            font-weight: 400;
                        }
                        .scenicLeftNav {
                            color: #333;
                            font-size: 14px;
                            font-weight: 400;
                            width: 240px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                            vertical-align: middle;
                            display: flex;
                            align-items: center;
                        }
                    }
                }
            }
        }
      }
      .noScenicList {
        height: 100%;
        .noScenic {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 120px;
          // height: 155px;
          .noScenicItem {
            margin-top: 30px;
            .noScenicItemImg {
              margin-bottom: 24px;
              display: flex;
              justify-content: center;
              img {
                display: inline-block;
                width: 74px;
                height: 62px;
              }
            }
            .noScenicItemContent {
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }
    .van-popup--bottom.van-popup--round {
      border-radius: 0
    }
    .van-action-sheet__header {
      text-align: left;
      margin-left: 16px;
      color: #333;
      font-size: 16px;
    }
    .van-button--round {
      border-radius: 0px;
    }
    /deep/.md-popup-mask {
      background-color: rgba(37,38,45,.3);
    }
    /deep/.van-overlay {
      background-color: rgba(37,38,45,.3);
    }
  }
</style>
